"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeisureSearchHeaderResponseSchema = void 0;
var zod_1 = require("zod");
var quick_filter_1 = require("../common/quick-filter");
var global_filter_1 = require("../common/global-filter");
var tab_info_1 = require("../common/tab-info");
var sort_info_1 = require("../common/sort-info");
var search_1 = require("./search");
exports.LeisureSearchHeaderResponseSchema = zod_1.z.object({
    tabInfo: tab_info_1.TabInfoSchema.nullish(),
    sortInfo: sort_info_1.SortInfoSchema.nullish(),
    quickFilter: quick_filter_1.QuickFilterSchema.nullish(),
    globalFilter: global_filter_1.GlobalFilterSchema.nullish(),
    hasSelectedFilter: zod_1.z.boolean().nullish(),
    /** 리스트 영역 조회를 위한 request 정보 */
    request: search_1.LeisureSearchRequestBodySchema,
});
